import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import Navbar from './components/Navbar.jsx';
import Bookings from './pages/Bookings';
import Companies from './pages/Companies';
import Categories from './pages/Categories';
import Offers from './pages/Offers';
import Transactions from './pages/Transactions';
import Users from './pages/Users';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Regions from './pages/Regions';
import './assets/styles/global.css';
import ContactUs from './pages/ContactUs';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <MainLayout navbar={<Navbar />}>
                <Routes>
                  <Route
                    path="/"
                    element={<Navigate to="/bookings" replace />}
                  />
                  <Route path="/bookings" element={<Bookings />} />
                  <Route path="/companies" element={<Companies />} />
                  <Route path="/categories" element={<Categories />} />
                  <Route path="/offers" element={<Offers />} />
                  <Route path="/transactions" element={<Transactions />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/regions" element={<Regions />} />
                  <Route path="/contactuses" element={<ContactUs />} />

                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </MainLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
